export const YOUTUBE_VIDEO_ADDED = 'YouTube Video Added'; // params: groupId, name, URL, duration
export const YOUTUBE_VIDEO_PLAYED = 'YouTube Video Played'; // params: groupId, name, URL
